
import MAP from '@/store/modules/MapModule';
import MISC_DATA from '@/store/modules/MiscDataModule';

export default {
	name: 'TruckPrice',
	props: {
		value: {
			type: [Number, String, Array],
			default: 100
		}
	},

	data() {
		return {
			localPrice: '',
			priceRange: {}
		};
	},
	computed: {
		MISC_DATA: () => MISC_DATA
	},
	watch: {
		value: {
			handler(newValue) {
				if (newValue) {
					this.localPrice = Array.isArray(newValue) ? newValue[0] : Number(newValue);
				} else {
					this.localPrice = this.priceRange.max; // Fallback to max value
				}
			},
			immediate: true
		}
	},
	mounted() {
		this.priceRange = this.MISC_DATA.data_per_bu.trucks.price_filter;
		this.localPrice = this.priceRange.max;
	},
	methods: {
		updatePrice() {
			this.$emit('input', this.localPrice);
			MAP.updateCurrentFilter({
				...MAP.current_filter,
				max_price: this.localPrice.toString()
			});
			this.$emit('fetch-trucks');
		}
	}
};
